import CONFIG from '../config/config';
import { instanceWithV2 as instance } from './SimpleAPIClient';
import { PaymentPlan, PaymentPlanItem, PaymentStatus, PaymentConcept } from '../types/payment-plan';

interface CommissionPaymentSplitDto {
  id?: number | null;
  amount: number;
  dueDate?: string;
  paymentMethod?: string;
  paid?: boolean;
  paidDate?: string;
  invoiceReference?: string;
  concept?: PaymentConcept | string;
  description?: string;
  validForDays?: number;
  isDisabled?: boolean;
}

interface CommissionPaymentPlanDto {
  id?: number;
  resourceId: string;
  totalAmount: number;
  currency: string;
  description?: string;
  status?: PaymentStatus | string;
  paymentSplits: CommissionPaymentSplitDto[];
}

interface CreateRequest {
  totalAmount: number;
  currency: string;
  description?: string;
  paymentSplits: CommissionPaymentSplitDto[];
}

const toFrontend = (dto: CommissionPaymentPlanDto): PaymentPlan => {
  return {
    id: dto.id ?? null,
    contractId: Number(dto.resourceId ?? 0),
    totalAmount: dto.totalAmount,
    currency: dto.currency,
    createdAt: '',
    updatedAt: '',
    items: (dto.paymentSplits || []).map((s) => ({
      id: s.id ?? null,
      amount: s.amount,
      currency: dto.currency,
      status: s.paid ? PaymentStatus.PAID : PaymentStatus.NOT_PAID,
      paidDate: s.paidDate,
      invoiceReference: s.invoiceReference,
      dueDate: s.dueDate,
      concept: (s.concept as PaymentConcept) ?? PaymentConcept.OTHER,
      description: s.description,
      validForDays: s.validForDays,
      isDisabled: Boolean(s.isDisabled),
      createdAt: '',
      updatedAt: ''
    })) as PaymentPlanItem[]
  } as PaymentPlan;
};

const toCreateRequest = (plan: PaymentPlan): CreateRequest => ({
  totalAmount: plan.totalAmount,
  currency: plan.currency,
  description: '',
  paymentSplits: plan.items.map(i => ({
    id: i.id,
    amount: i.amount,
    dueDate: i.dueDate,
    paymentMethod: undefined,
    paid: i.status === PaymentStatus.PAID,
    paidDate: i.paidDate,
    invoiceReference: i.invoiceReference,
    concept: i.concept as PaymentConcept,
    description: i.description,
    validForDays: i.validForDays,
    isDisabled: i.isDisabled
  }))
});

const toUpdateRequest = toCreateRequest;

const CommissionPaymentPlansAPI = {
  get: (contractId: number) =>
    instance(CONFIG.API_ENDPOINT).get<CommissionPaymentPlanDto>(`v1/commission-contracts/${contractId}/payment-plan`),
  create: (contractId: number, plan: PaymentPlan) =>
    instance(CONFIG.API_ENDPOINT).post<CommissionPaymentPlanDto>(`v1/commission-contracts/${contractId}/payment-plan`, toCreateRequest(plan)),
  update: (contractId: number, plan: PaymentPlan) =>
    instance(CONFIG.API_ENDPOINT).put<CommissionPaymentPlanDto>(`v1/commission-contracts/${contractId}/payment-plan`, toUpdateRequest(plan)),
  remove: (contractId: number) =>
    instance(CONFIG.API_ENDPOINT).delete<void>(`v1/commission-contracts/${contractId}/payment-plan`),
  createSplitCheckout: (trackingId: string, splitId: string | number) => instance(CONFIG.API_ENDPOINT).post<string>(`v1/public/commission-contracts/tracking/${trackingId}/payment/splits/${splitId}/checkout`),
};

export { toFrontend };
export default CommissionPaymentPlansAPI;


